/** The level of information that the order might contain. */
enum OrderInfoLevel {
  /** An order is considered as basic when the source is Mds. */
  Basic = 'basic',
  /**
   * An order is considered "complete" when the source is from AWS or
   * using a single order lookup to Mds.
   */
  Complete = 'complete'
}

export default OrderInfoLevel;
